import React, { Component } from 'react';
import { Toast, SearchBar } from 'antd-mobile';
import PropTypes from 'prop-types';
import styles from './styles.module.less';
import { getShoppingRoom, getShoppingRoomLive } from '../../service/chat-service';
import time from '../../public/images/time.png';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

const defaultProps = {};
class index extends Component {
  end = false

  constructor(props) {
    super(props);
    const windowHref = `?${decodeURIComponent(window.location.href).split('?')[1]}`;
    const companyCode = new URLSearchParams(windowHref).get('companyCode');
    const shareUserId = new URLSearchParams(windowHref).get('shareUserId');
    this.state = {
      pageList: [],
      shopList: [],
      pageNum: 1,
      pageSize: 10,
      loading: false,
      companyCode,
      shareUserId,
    };
  }

  componentDidMount() {
    document.title = '店铺';
    this.getRoomLiveList();// 直播
    this.loadData();// 商品
    this.addScrollEvent();
  }

  componentWillUnmount() {
    this.removeScrollEvent();
  }

  scrollBottomLoad = () => {
    const { pageNum, loading } = this.state;
    if (this.end || loading) return false;
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    const bodyHeight = document.getElementById('order_content_H9').clientHeight;
    const { clientHeight } = document.documentElement;

    if (scrollTop + clientHeight === bodyHeight) {
      this.loadData(pageNum + 1);
    }
    return true;
  }

  addScrollEvent = () => {
    window.addEventListener('scroll', this.scrollBottomLoad);
  }

  removeScrollEvent = () => window.removeEventListener('scroll', this.scrollBottomLoad)

  // 商品列表加载
  loadData = async (pageNum2) => {
    const { pageNum, companyCode } = this.state;
    const pageNum1 = pageNum2 || pageNum;
    const { pageSize, pageList } = this.state;
    const obj = {
      companyCode,
      pageNum: pageNum1,
      pageSize,
    };

    if (this.end) return false;
    this.setState({ loading: true });

    try {
      const { data } = (await getShoppingRoom(obj)) || {};

      let orderList = pageList;
      if (Array.isArray(data) && data.length) {
        if (data.length < pageSize) this.end = true;
        orderList = pageList.concat(data);
      }
      this.setState({ pageList: orderList, pageNum: pageNum1, loading: false });
    } catch (e) {
      Toast.show(e.message);
      this.setState({ loading: false });
    }
    return true;
  }

  // 商品列表搜索
  getShoppingRoomList = async (name) => {
    const { companyCode } = this.state;
    try {
      const { code, data, message } = await getShoppingRoom({ companyCode, name });
      if (code === 10000) {
        this.setState({ pageList: data });
      } else {
        Toast.show(message);
      }
    } catch (e) {
      Toast.show(e);
    }
  }

  // 直播列表
  getRoomLiveList = async (name) => {
    const { companyCode } = this.state;

    try {
      const { code, data, message } = await getShoppingRoomLive({
        companyCode, name, pageNum: 1, pageSize: 2,
      });
      if (code === 10000) {
        this.setState({ shopList: data });
      } else {
        Toast.show(message);
      }
    } catch (e) {
      Toast.show(e);
    }
  }

  // 搜索
  searchValue=(value) => {
    this.getShoppingRoomList(value);
    this.getRoomLiveList(value);
  }

  cancel=() => {
    this.getShoppingRoomList();
    this.getRoomLiveList();
  }

  liveListRenderingOpen=(id) => {
    const { history } = this.props;
    const { shareUserId } = this.state;
    history.push(`/signUp?id=${id}&staffUserId=${shareUserId}`);
  }

  // 直播活动列表渲染
  liveListRendering=() => {
    const { shopList } = this.state;
    return shopList.map((item) => (
      <div
        key={item.livePicAddress}
        className={styles.shopPage}
        role="button"
        tabIndex={0}
        onClick={this.liveListRenderingOpen.bind(null, item.id)}
      >
        <div className={styles.shopPageL}>
          <img src={item.livePicAddress} alt="" />
        </div>
        <div className={styles.shopPageR}>
          <div>
            <div>{item.liveName}</div>
          </div>
          <div>
            <span>
              <img src={time} alt="" />
            </span>
            <span>
              {item.expectedStartTime}
            </span>
          </div>
        </div>
      </div>
    ));
  }

  shopListRenderingOpen=(id) => {
    const { history } = this.props;
    const { shareUserId } = this.state;
    history.push(`/productDetail?productId=${id}&shareUserId=${shareUserId}`);
  }

    // 商品列表渲染
    shopListRendering=() => {
      const { pageList } = this.state;
      return pageList.map((item) => (
        <div
          key={item.id}
          className={styles.shopBox}
          role="button"
          tabIndex={0}
          onClick={this.shopListRenderingOpen.bind(null, item.id)}
        >
          <div><img src={item.imgUrl} alt="" /></div>
          <div className={styles.shopdai}>
            <div>{item.productName}</div>
            <div>
              <span style={{ color: 'red' }}>
                ￥
                {item.priceType === 4 ? (item.specPrice / 100) : '' }
                { item.priceType === 1 ? (item.price / 100) : ''}
              </span>
              <s style={{ marginLeft: 5 }}>
                {item.priceType === 4 ? (item.specOriginalPrice / 100) : '' }
                { item.priceType === 1 ? (item.originalPrice / 100) : ''}
              </s>
            </div>
          </div>
        </div>
      ));
    }

    golink = () => {
      const { history } = this.props;
      const { shareUserId, companyCode } = this.state;
      history.push(`/liveList?companyCode=${companyCode}&shareUserId=${shareUserId}`);
    }

    render() {
      return (
        <div className={styles.body} id="order_content_H9">
          <SearchBar placeholder="搜索关键词或标签" onSubmit={this.searchValue} onCancel={this.cancel} />
          <div className={styles.livelist}>
            <div className={styles.livelistTit}>
              <span>直播活动</span>
              <span role="button" tabIndex={0} onClick={this.golink}>
                更多》
              </span>
            </div>
            {this.liveListRendering()}
          </div>
          <div
            className={styles.livelist}
            style={{
              background: '#F7F7F7',
            }}
          >
            <div className={styles.livelistTit}>
              <span>商品列表</span>
            </div>
            <div className={styles.shopcss}>
              {this.shopListRendering()}
            </div>
          </div>
        </div>
      );
    }
}

index.propTypes = propTypes;
index.defaultProps = defaultProps;

export default index;
